import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[isRequired]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IsRequiredDirective, multi: true }]
})
export class IsRequiredDirective {

  constructor() { }
  public validate(control: AbstractControl): { [key: string]: any } {
    if (control.value === null || control.value === undefined) {
      return { 'isRequired': true };
    }
    else {
      if (control.value.trim().length == 0) {
        return { 'isRequired': true };
      }
      else {
        return null;
      }
    }
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/is-required.directive.ts